import { fromJS } from 'immutable'
import {
  TEAM_GET_REQUEST,
  TEAM_GET_SUCCESS,
  TEAM_GET_FAILURE,
  TEAM_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TEAM_GET_REQUEST:
      return state
        .set('isFetching', true)
    case TEAM_GET_SUCCESS:
      return state
        .set('isFetching', false)
        .set('team', fromJS(action.payload.team))
    case TEAM_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case TEAM_GET_RESET:
      return state
        .delete('team')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/team/team-get-reducer.js